import Asset from "backbone/projects/models/asset.js"

export default class AssetsCollection extends Backbone.Collection
  model: Asset



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/collections/assets_collection.js.coffee